import { Button, DialogFooter } from "@/shared";
import { useAppDispatch, useAppSelector } from "@store";
import { setDialogId } from "@store/global-slice";
import { updateStorySettings } from "@store/story";
import { getSettings } from "@store/story/selectors";
import { useCallback } from "react";

export const Footer = ({
  selected,
  id,
}: {
  selected: "all" | "mentions" | "none";
  id: string;
}) => {
  const dispatch = useAppDispatch();
  const settings = useAppSelector(getSettings);

  const submit = useCallback(() => {
    dispatch(setDialogId({ id: null }));
    const notificationSettings = { ...(settings?.notificationSettings || {}) };
    notificationSettings[id] = selected;

    dispatch(
      updateStorySettings({
        payload: { notificationSettings },
        autosave: true,
      }),
    );
  }, [dispatch, id, selected, settings]);

  const close = () => {
    dispatch(setDialogId({ id: null }));
  };

  return (
    <DialogFooter>
      <Button
        title="Go back"
        size="large"
        variant="secondary"
        onClick={close}
        className="tw-mr-4"
      />
      <Button title="Update" size="large" variant="primary" onClick={submit} />
    </DialogFooter>
  );
};
